<svelte:options customElement="icon-building" />

<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none">
	<path
		stroke="#172E44"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="1.5"
		d="M23.75 26.25v-20a2.5 2.5 0 0 0-2.5-2.5H8.75a2.5 2.5 0 0 0-2.5 2.5v20m17.5 0h2.5m-2.5 0H17.5m-11.25 0h-2.5m2.5 0h6.25m5 0V20a1.25 1.25 0 0 0-1.25-1.25h-2.5A1.25 1.25 0 0 0 12.5 20v6.25m5 0h-5m-1.25-17.5h1.25m-1.25 5h1.25m5-5h1.25m-1.25 5h1.25"
	/>
</svg>
